import throttle from './base/_throttle.js';
import Masthead from './modules/_masthead.js';
import SectionNav from './modules/_section-nav.js';
import { animate } from './modules/_animations.js';

import './base/_share.js';
import './base/_object-fit-cover.js';
import fitvid from './base/_fitvid.js';
import './modules/_announcement.js';

class Scripts {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', this.ready.bind( this ) );
		window.addEventListener( 'resize', throttle( this.resize.bind( this ), 25 ) );
		this.resize();
	}

	ready() {
		this.sectionnav = new SectionNav();
		this.masthead   = new Masthead();

		this.prepareFeaturedCaseStudy();
		document.querySelectorAll('[data-animation]').forEach( node => {
			animate( node )
		});

		fitvid();
	}

	resize() {
		if ( ! document.body ) {
			return;
		}

		// using this to allow css to know if it should exclude the scroll bar in calc's
		if ( window.innerWidth === document.body.clientWidth ) {
			document.documentElement.classList.remove( 'has-scrollbar' );
		} else {
			document.documentElement.classList.add( 'has-scrollbar' );
		}
	}

	prepareFeaturedCaseStudy() {
		document.querySelectorAll('.featured-case-study').forEach( node => {
			const heading  = node.querySelector( '.featured-case-study__column-left .wp-block-heading:first-child' );
			const excerpts = node.querySelectorAll( '.featured-case-study__column-left .excerpt' );

			if ( heading ) {
				heading.dataset.animation = 'block';
			}

			let   animationCount = 0;
			const animationDelay = 150;

			excerpts.forEach( excerpt => {
				const image   = excerpt.querySelector( '.excerpt__image' );
				const types   = excerpt.querySelector( '.excerpt__types' );
				const title   = excerpt.querySelector( '.excerpt__title a' );
				const footer  = excerpt.querySelector( '.excerpt__footer' );

				if ( image ) {
					image.dataset.animation = 'image';
					image.dataset.animationDelay = animationCount * animationDelay;
					animationCount++;
				}

				if ( types ) {
					types.dataset.animation = 'block';
					types.dataset.animationDelay = animationCount * animationDelay;
					animationCount++;
				}

				if ( title ) {
					title.dataset.animation = 'lines';
					title.dataset.animationDelay = animationCount * animationDelay;
					animationCount++;
				}

				if ( footer ) {
					footer.dataset.animation = 'block';
					footer.dataset.animationDelay = animationCount * animationDelay;
					animationCount++;
				}
			} );
		} );
	}
}

export default new Scripts;
